import { createSelector } from 'reselect'
import { AppState } from '../store'

// export const selectTodo = (state: AppState) => state.todos
export const selectGame = (state: AppState) => state.game

export const getGameSelector = createSelector(selectGame, (game) => game)
